import { format, fromUnixTime } from 'date-fns';

import { toDate } from './toDate';

const API_LOCAL_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';
const DISPLAY_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
const SHORT_DATE_FORMAT = 'dd MMM yyyy';
const FILTER_DATE_FORMAT = 'dd.MM.yyyy';

export const formatLocalDateTimeIso = (date: Date) =>
  format(date, API_LOCAL_DATE_TIME_FORMAT);

export const formatDisplayDate = (date: Date | string) =>
  format(toDate(date), DISPLAY_DATE_FORMAT);

export const formatDisplayDateTime = (date: Date | string) =>
  format(toDate(date), DISPLAY_DATE_TIME_FORMAT);

export const formatShortDate = (date: Date | string) =>
  format(toDate(date), SHORT_DATE_FORMAT);

export const formatFilterDate = (date: Date) =>
  format(date, FILTER_DATE_FORMAT);

export const formatFilterDateRange = (from: Date, to: Date) =>
  `${formatFilterDate(from)} – ${formatFilterDate(to)}`;

export const formatUnixTimestampShortDate = (timestamp: string | number) =>
  format(fromUnixTime(Number(timestamp)), SHORT_DATE_FORMAT);
